import { createFileRoute } from "@tanstack/react-router";
import { FunctionDetail } from "../../features/functions/function-detail";

export const Route = createFileRoute("/_authed/$org/$project/functions/$name/$tab")({ component: FunctionPage });

function FunctionPage() {
  const { org, project, name, tab } = Route.useParams();
  return <FunctionDetail scope={{ org, project }} name={name} tab={tab} />;
}
